import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showSuccessToast} from "vant";


const baseUrl = `${process.env.VUE_APP_API_URL}/user/exercises`;

export const useUserExerciseStore = defineStore({
    id: 'userExercise',
    state: () => ({
        exercises: [],
        userExercise: {},
        name: '',
        type: '',
    }),
    actions: {
        async fetchAll() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + '?name=' + this.name + "&type=" + this.type + "&account_id=" + accountId, null);
            this.exercises = response.data;
        },
        async fetchOne(id) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + id +"?account_id=" + accountId, null);
            this.userExercise = response.data;
        },
        async updateResource(id) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.put(`${baseUrl}/` + id +"?account_id=" + accountId, {});
            this.userExercise = response.data;
            showSuccessToast('Updated');
        },
    }
});
